import { TextField as NovaTextField } from '@fme-nova/components'
import { default as MuiBaseTextField, TextFieldProps } from '@mui/material/TextField'

import { createComponentWrapperWithRef } from '../../theme'

export const TextField = createComponentWrapperWithRef<TextFieldProps>(
  {
    mui: MuiBaseTextField,
    nova: NovaTextField as React.ElementType<TextFieldProps>,
    propsEnhancer(props, componentLibrary) {
      if (componentLibrary === 'nova' && (!props.variant || props.variant === 'standard')) {
        props.variant = undefined
      }
      return props
    },
  },
  'TextField',
)
